/**
 * DEPRECATED — v10.3.0
 *
 * Este archivo se mantiene por retrocompatibilidad. La lógica real de
 * generación de ondas fisiológicas vive ahora en
 * `/app/frontend/src/components/waveforms/`.
 *
 * Usar en su lugar:
 *   import { resolveSignalConfig, sampleECG, samplePleth, sampleRespiration } from '../waveforms';
 */
import {
  resolveSignalConfig,
  resolveRhythm,
  sampleECG,
  PULSELESS_RHYTHMS,
  FLATLINE_RHYTHMS,
  FALLBACK_RHYTHM_LABELS,
} from '../waveforms';

// Shim para código legacy que llamaba a sampleEcg(rhythm, hr, timeMs)
// y esperaba un valor centrado en 50 (baseline visual del monitor viejo).
export function sampleEcg(rhythm, hr, timeMs) {
  const cfg = resolveSignalConfig({ ritmo_ecg: rhythm, fc: hr }, null);
  cfg._vitals = { ritmo_ecg: rhythm, fc: hr };
  return 50 + sampleECG(timeMs, cfg);
}

export function deriveRhythm(fc) {
  return resolveRhythm({ fc });
}

// Los siguientes exports se conservan para código legacy que aún los use
export const NO_PLETH_RHYTHMS = ['fibrilacion_ventricular', 'asistolia', 'aesp'];
export { PULSELESS_RHYTHMS, FLATLINE_RHYTHMS, FALLBACK_RHYTHM_LABELS };
